<template>
  <!-- //////////////////////////////////////////////////////////////////// Betagro //////////////////////////////////////////////////////////////// -->
  <div>
    <div v-if="user === 'betagrodemo' || admin == 'betagrodemo'">
      <vs-row style="display: flex; align-items: center">
        <img
          style="width: 17%; height: 14%"
          src="@/assets/images/betagro/belogo.png"
        />
        <a
          class="mt-2"
          style="
            font-family: 'Kanit', sans-serif;
            font-size: 1.2rem;
            color: white;
          "
        >
          สาขา{{ valueName }}
        </a>
        <vs-button v-b-modal.modal-editname radius color="light" type="flat" v-if="admin == user"
          ><span>
            <vs-icon
              class="mt-2"
              icon="edit"
              size="18px"
              color="success"
            ></vs-icon> </span
        ></vs-button>
      </vs-row>
      <!-- <div class="bg-danger"> <pre>  {{itemTemp}}</pre>  {{optionsColorC[1].value2}} <=
                        i.sensordata.temperature <=
                  "
                        {{optionsColorC[1].value1}}{{optionsColorC}}</div
                        > -->
      <vs-row vs-w="12">
        <vs-col
          style="padding: 0px"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <!-- <v-zoomer> -->
            <div class="img-wraps container-fluid">
              <span
                style="width: 11%; height: 12%"
                :class="i.location"
                v-for="i in itemTemp"
                :key="i"
              >
                <vs-tooltip :text="i.name">
                  <span
                    style="
                      font-size: 0.6rem;
                      font-weight: 100;
                      position: absolute;
                      width: 100%;
                      top: 34%;
                      color: white;
                      right: 2%;
                    "
                    >{{ i.sensordata.temperature.toFixed(0) }}°C
                  </span>
                </vs-tooltip>
                <!-- Zone Chill -->
                <!-- Red -->
                <img
                  v-if="
                    itemZoneC.includes(i.location) &&
                    i.sensordata.temperature > optionsColorC[0].value2
                  "
                  style="width: 100%; height: 100%"
                  src="@/assets/images/betagro/gif/d.gif"
                />
                <!-- Yellow -->
                <img
                  v-else-if="
                    itemZoneC.includes(i.location) &&
                    optionsColorC[1].value1 <= i.sensordata.temperature &&
                    i.sensordata.temperature <= optionsColorC[1].value2
                  "
                  style="width: 100%; height: 100%"
                  src="@/assets/images/betagro/gif/k.gif"
                />
                <!-- Green -->
                <img
                  v-else-if="
                    itemZoneC.includes(i.location) &&
                    i.sensordata.temperature < optionsColorC[2].value2
                  "
                  style="width: 100%; height: 100%"
                  src="@/assets/images/betagro/gif/output-onlinegiftools (10).gif"
                />
                <!-- Zone Freeze -->
                <!-- Red -->
                <img
                  v-else-if="
                    itemZoneF.includes(i.location) &&
                    i.sensordata.temperature > optionsColor[0].value2
                  "
                  style="width: 100%; height: 100%"
                  src="@/assets/images/betagro/gif/d.gif"
                />
                <!-- Yellow -->
                <img
                  v-else-if="
                    itemZoneF.includes(i.location) &&
                    optionsColor[1].value1 <= i.sensordata.temperature &&
                    i.sensordata.temperature <= optionsColor[1].value2
                  "
                  style="width: 100%; height: 100%"
                  src="@/assets/images/betagro/gif/k.gif"
                />
                <!-- Green -->
                <img
                  v-else-if="
                    itemZoneF.includes(i.location) &&
                    i.sensordata.temperature < optionsColor[2].value2
                  "
                  style="width: 100%; height: 100%"
                  src="@/assets/images/betagro/gif/output-onlinegiftools (10).gif"
                />
              </span>
              <span
                style="width: 7%; height: 10%"
                :class="i.location + 'D'"
                v-for="i in itemDoor"
                :key="i"
              >
                <vs-tooltip :text="i.name">
                  <img
                    v-if="
                      itemZoneF.includes(i.location) &&
                      i.sensordata.unlocked == false
                    "
                    style="width: 100%; height: 100%"
                    src="@/assets/images/betagro/gif/door45.png"
                  />
                  <img
                    v-if="
                      itemZoneF.includes(i.location) &&
                      i.sensordata.unlocked == true
                    "
                    style="width: 100%; height: 100%"
                    src="@/assets/images/betagro/gif/door44.gif"
                  />
                  <img
                    v-if="
                      itemZoneC1.includes(i.location) &&
                      i.sensordata.unlocked == false
                    "
                    style="width: 50%; height: 50%"
                    src="@/assets/images/betagro/gif/door3.png"
                  />
                  <img
                    v-if="
                      itemZoneC1.includes(i.location) &&
                      i.sensordata.unlocked == true
                    "
                    style="width: 100%; height: 100%"
                    src="@/assets/images/betagro/gif/door4.gif"
                  />
                  <img
                    v-if="
                      itemZoneC2.includes(i.location) &&
                      i.sensordata.unlocked == false
                    "
                    style="width: 50%; height: 50%"
                    src="@/assets/images/betagro/gif/door.png"
                  />
                  <img
                    v-if="
                      itemZoneC2.includes(i.location) &&
                      i.sensordata.unlocked == true
                    "
                    style="width: 100%; height: 100%"
                    src="@/assets/images/betagro/gif/C2open.gif"
                  />
                </vs-tooltip>
              </span>

              <img
                class="imgMapFreacer"
                style="width: 100%; height: 100%"
                src="@/assets/images/betagro/betragroD.png"
              /></div>
              <!-- </v-zoomer> -->
        </vs-col>
        <vs-col
          style="padding: 0px"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <vs-card style="margin: auto; border-radius: 20px">
            <vs-row>
              <vs-row class="mb-2">
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="12"
                >
                  <vs-table :data="itemTemp" class="container-fluid">
                    <template slot="header">
                      <vs-list-header
                        title="Temperature Sensor List"
                        style="font-size: 18px"
                        color="primary"
                      ></vs-list-header
                      ><vs-spacer />
                      <!-- <b-button >Chart</b-button> -->
                      <span>
                        <vs-icon
                          v-if="admin == user"
                          icon="settings"
                          v-b-modal.modal-2
                          size="20px"
                          color="success"
                        ></vs-icon>
                      </span>
                    </template>
                    <template slot="thead">
                      <vs-th
                        style="background: #484848; color: #ffffff"
                        v-for="i in headerTableMap"
                        :key="i"
                        sort-key="name"
                      >
                        {{ i }}
                      </vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr
                        style="background: #212121; color: #ffffff"
                        :key="indextr"
                        v-for="(tr, indextr) in data"
                      >
                        <vs-td :data="data[indextr].name">
                          {{ data[indextr].name }}
                        </vs-td>
                        <vs-td :data="data[indextr].sensordata.temperature">
                          {{ data[indextr].sensordata.temperature }}
                        </vs-td>
                        <vs-td :data="data[indextr].sensordata.humidity">
                          {{ data[indextr].sensordata.humidity }}
                        </vs-td>
                        <vs-td :data="data[indextr].sensordata.battery">
                          {{ data[indextr].sensordata.battery }}
                        </vs-td>
                        <vs-td :data="data[indextr].lastdate">
                          {{ data[indextr].lastdate }}
                        </vs-td>

                        <!-- <vs-td :data="data[indextr].lastdate">
                          <span v-if="this.curt.diff(moment(data[indextr].lastdate),'m') <= 2"
                            >Open</span
                          >
                          <span v-if="this.curt.diff(moment(data[indextr].lastdate),'m') < 2"
                            >Open</span
                          >
                        </vs-td> -->

                        <vs-td :data="data[indextr].location">
                          <div v-if="admin == user">
                          <vs-select
                            style="color: #111111"
                            width="100px"
                            @change="changeLocation(data[indextr])"
                            v-model="data[indextr].location"
                          >
                            <vs-select-item
                              :key="index"
                              :value="item.text"
                              :text="item.text"
                              v-for="(item, index) in options1"
                            />
                          </vs-select>
                          </div>
                          <div v-else>
                            <span>{{data[indextr].location}}</span>
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="12"
                >
                  <vs-table :data="itemDoor" class="container-fluid">
                    <template slot="header">
                      <vs-list-header
                        title="Door Sensor List"
                        style="font-size: 18px"
                        color="primary"
                      ></vs-list-header>
                    </template>
                    <template slot="thead">
                      <vs-th
                        style="background: #484848; color: #ffffff"
                        v-for="i in headerTableMap2"
                        :key="i"
                      >
                        {{ i }}
                      </vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr
                        style="background: #212121; color: #ffffff"
                        :key="indextr"
                        v-for="(tr, indextr) in data"
                      >
                        <vs-td :data="data[indextr].name">
                          {{ data[indextr].name }}
                        </vs-td>
                        <vs-td :data="data[indextr].sensordata.uninstalled">
                          <span
                            v-if="data[indextr].sensordata.uninstalled == true"
                            >Uninstall</span
                          >
                          <span
                            v-if="data[indextr].sensordata.uninstalled == false"
                            >Install</span
                          >
                        </vs-td>
                        <vs-td :data="data[indextr].sensordata.unlocked">
                          <span v-if="data[indextr].sensordata.unlocked == true"
                            >Open</span
                          >
                          <span
                            v-if="data[indextr].sensordata.unlocked == false"
                            >Off</span
                          >
                        </vs-td>

                        <vs-td :data="data[indextr].sensordata.battery">
                          {{ data[indextr].sensordata.battery }}
                        </vs-td>
                        <vs-td :data="data[indextr].lastdate">
                          {{ data[indextr].lastdate }}
                        </vs-td>
                        <vs-td :data="data[indextr].location">
                          <div v-if="admin == user">
                          <vs-select
                            style="color: #111111"
                            width="100px"
                            @change="changeLocation(data[indextr])"
                            v-model="data[indextr].location"
                          >
                            <vs-select-item
                              :key="index"
                              :value="item.text"
                              :text="item.text"
                              v-for="(item, index) in options1"
                            />
                          </vs-select>
                          </div>
                          <div v-else>
                            <span>{{data[indextr].location}}</span>
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </vs-col>
              </vs-row>
            </vs-row>
          </vs-card>
        </vs-col>
      </vs-row>

      <br />

      <vs-row>
        <vs-col style="padding: 0px" vs-lg="9" vs-sm="12" vs-xs="12">
          <vs-row vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="12"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-col>
                <vs-card
                  id="pbGraph"
                  style="border-radius: 15px; padding-left: 5"
                >
                  <vs-row class="mt-2">
                    <vs-list-header
                      title="Time Series"
                      class="fontBetagro"
                      color="primary"
                    ></vs-list-header
                    ><vs-spacer />
                    <!-- <b-button >Chart</b-button> -->
                    <span>
                      <vs-icon
                        icon="settings"
                        v-b-modal.modal-1
                        size="25px"
                        color="success"
                      ></vs-icon>
                    </span>
                  </vs-row>
                  <vs-row class="mt-1">
                    <vs-list-header
                      :title="arrSensorName"
                      class="fontBetagro"
                      color="rgb(126, 126, 126)"
                    ></vs-list-header>
                    <!-- <vs-spacer />
                    <span>
                      <vs-icon
                        icon="settings"
                        v-b-modal.modal-1
                        size="25px"
                        color="success"
                      ></vs-icon>
                    </span>  -->
                  </vs-row>
                  <br /><br /><br /><br />
                  <div id="app">
                    <SensorChart
                      v-if="chart"
                      :chartData="this.chartData"
                      :options="this.options"
                      style="height: 300px"
                    />
                  </div>
                  <br /><br /><br /><br />
                </vs-card>
              </vs-col>
            </vs-col>
          </vs-row>
        </vs-col>

        <vs-col style="padding: 0px" vs-lg="3" vs-sm="12" vs-xs="12">
          <div>
            <vs-card class="mr-3" style="border-radius: 15px">
              <vs-row>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="5"
                >
                  <img
                    width="150"
                    height="150"
                    src="@/assets/images/betagro/34.png"
                    alt=""
                  />

                  <!-- <vs-icon icon="polymer" size="75px" color="success"></vs-icon> -->
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="7"
                >
                  <vs-row>
                    <vs-col
                      class="mt-2"
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="12"
                    >
                      <!-- <vs-icon color="#FF144D" icon="arrow_upward"></vs-icon>  -->
                      <h5 class="fontColorHeaderAVG textDanger">Max Temp</h5>
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="12"
                      class="mb-2"
                    >
                      <h5 class="textDanger fontSize2">{{ maxValTemp }} ํC</h5>
                    </vs-col>
                    <vs-col
                      class="mt-2"
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="12"
                    >
                      <!-- <vs-icon color="#00BBFF" icon="arrow_downward"></vs-icon>  -->
                      <h5 class="fontColorHeaderAVG textInfo">Min Temp</h5>
                    </vs-col>
                    <vs-col
                      class="mb-3"
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="12"
                    >
                      <h5 class="textInfo fontSize2">{{ minValTemp }} ํC</h5>
                    </vs-col>
                    <vs-col
                      class="mt-2"
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="12"
                    >
                      <h5 class="fontColorHeaderAVG textSuccess">Avg Temp</h5>
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      class="mb-3"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="12"
                    >
                      <h5 class="textSuccess fontSize2">
                        {{ avgValTemp.toFixed(2) }} ํC
                      </h5>
                    </vs-col>
                  </vs-row>
                </vs-col>
              </vs-row>
            </vs-card>
            <vs-card class="mr-3" style="border-radius: 15px">
              <vs-row>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="5"
                >
                  <img
                    width="150"
                    height="150"
                    src="@/assets/images/betagro/2121.png"
                    alt=""
                  />
                </vs-col>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="7"
                >
                  <vs-row>
                    <vs-col
                      class="mt-2"
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="12"
                    >
                      <!-- <vs-icon color="#FF144D" icon="arrow_upward"></vs-icon>  -->
                      <h5 class="fontColorHeaderAVG textDanger">Max Humid</h5>
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="12"
                      class="mb-3"
                    >
                      <h5 class="textDanger fontSize2">{{ maxValHumid }} %</h5>
                    </vs-col>
                    <vs-col
                      class="mt-2"
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="12"
                    >
                      <!-- <vs-icon color="#00BBFF" icon="arrow_downward"></vs-icon>  -->
                      <h5 class="fontColorHeaderAVG">Min Humid</h5>
                    </vs-col>
                    <vs-col
                      class="mb-3"
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="12"
                    >
                      <h5 class="textInfo fontSize2">{{ minValHumid }} %</h5>
                    </vs-col>
                    <vs-col
                      class="mt-2"
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="12"
                    >
                      <h5 class="fontColorHeaderAVG textSuccess">Avg Humid</h5>
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      class="mb-3"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="12"
                    >
                      <h5 class="textSuccess fontSize2">
                        {{ avgValHumid.toFixed(2) }} %
                      </h5>
                    </vs-col>
                  </vs-row>
                </vs-col>
              </vs-row>
            </vs-card>
          </div>
        </vs-col>
      </vs-row>

      <vs-row>
        <b-modal
          id="modal-editname"
          ref="editname"
          hide-header-close
          centered
          size="lg"
        >
          <template #modal-title>
            <h4 class="textSuccess">Edit Branch Name</h4>
          </template>

          <vs-row style="display: flex; align-items: center">
            <a class="mr-2">Branch Name</a>
            <vs-input
              style="width: 300px"
              placeholder="Placeholder"
              v-model="valueName"
            />
          </vs-row>
          <template #modal-footer="{}">
            <vs-button
              color="primary"
              class="mr-2 btnBorderpop"
              @click="saveEditname(valueName)"
              type="filled"
              >Submit</vs-button
            >
            <vs-button
              color="dark"
              class="btnBorderpop"
              @click="closeEditname"
              type="flat"
              >Cancel</vs-button
            >
          </template>
        </b-modal>
        <b-modal
          id="modal-1"
          ref="settingChart"
          hide-header-close
          centered
          size="lg"
        >
          <template #modal-title>
            <h4 class="textSuccess">Select Date</h4>
          </template>
          <!-- {{ arrSensor }} -->

          <vs-row>
            <vs-col class="mt-2" vs-lg="4" vs-xs="12">
              <a class="ml-1">Select Sensor</a>
              <vs-select
                class="mt-1"
                style="width: 100%"
                multiple
                autocomplete
                v-model="arrSensor"
              >
                <vs-select-item
                  :key="index"
                  :value="item"
                  :text="item.name"
                  v-for="(item, index) in select"
                />
              </vs-select>
            </vs-col> </vs-row
          ><br />
          <vs-row>
            <vs-col class="mt-2" vs-lg="4" vs-xs="12">
              <a class="ml-1">Select Start Date</a>
              <!-- <datetime v-model="mintime" format="YYYY/MM/DD H:i:s" bootstrap-styling = "true" /> -->
              <datetime
                class="mt-2"
                v-model="mintime"
                type="datetime"
                input-class="form-control"
                placeholder="YYYY/MM/DD H:i:s"
              ></datetime>
            </vs-col>
            <vs-col class="mt-2" vs-lg="4" vs-xs="12">
              <a class="ml-1">Select End Date</a>
              <!-- <datetime v-model="maxtime" format="YYYY/MM/DD H:i:s"/> -->
              <datetime
                class="mt-2"
                v-model="maxtime"
                type="datetime"
                input-class="form-control"
                placeholder="YYYY/MM/DD H:i:s"
              ></datetime>
            </vs-col>
          </vs-row>
          <template #modal-footer="{}">
            <vs-button
              color="success"
              class="mr-2 btnBorderpop"
              @click="getChartData()"
              type="filled"
              >OK</vs-button
            >
            <vs-button
              class="btnBorderpop"
              color="dark"
              @click="closeModal"
              type="flat"
              >Cancel</vs-button
            >
          </template>
        </b-modal>
        <b-modal
          id="modal-2"
          ref="modal-2"
          hide-header-close
          centered
          size="lg"
        >
          <template #modal-title>
            <h4 class="textSuccess">Color Rule Setting</h4>
          </template>
          <span
            class="mb-2"
            style="
              font-size: 0.85rem;
              padding-left: 5px;
              color: rgba(0, 0, 0, 0.6);
            "
            >Select Color Rule of Freezer</span
          >
          <!-- <pre>{{optionsColor}}</pre>
           <pre>{{optionsColorC}}</pre> -->
          <vs-row class="mb-3 mt-3" v-for="i in optionsColor" :key="i" vs-w="8">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="3"
              vs-sm="4"
              vs-xs="3"
            >
              <span :class="i.color">{{ i.text }}</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="3"
              vs-sm="4"
              vs-xs="2"
            >
              <input
                v-if="i.value1"
                type="”number”"
                style="
                  width: 50%;
                  border: 1px solid rgba(0, 0, 0, 0.2);
                  padding: 0.4rem;
                "
                v-model="i.value1"
              />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="1"
            >
              {{ i.icon }}
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="3"
              vs-sm="4"
              vs-xs="2"
            >
              <input
                type="”number”"
                style="
                  width: 50%;
                  border: 1px solid rgba(0, 0, 0, 0.2);
                  padding: 0.4rem;
                "
                v-model="i.value2"
              />
            </vs-col>
          </vs-row>
          <span
            class="mb-2"
            style="
              font-size: 0.85rem;
              padding-left: 5px;
              color: rgba(0, 0, 0, 0.6);
            "
            >Select Color Rule of Chiller</span
          >
          <vs-row
            class="mb-3 mt-3"
            v-for="i in optionsColorC"
            :key="i"
            vs-w="8"
          >
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="3"
              vs-sm="4"
              vs-xs="3"
            >
              <span :class="i.color">{{ i.text }}</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="3"
              vs-sm="4"
              vs-xs="2"
            >
              <input
                v-if="i.value1"
                type="”number”"
                style="
                  width: 50%;
                  border: 1px solid rgba(0, 0, 0, 0.2);
                  padding: 0.4rem;
                "
                v-model="i.value1"
              />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="1"
            >
              {{ i.icon }}
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="3"
              vs-sm="4"
              vs-xs="2"
            >
              <input
                type="”number”"
                style="
                  width: 50%;
                  border: 1px solid rgba(0, 0, 0, 0.2);
                  padding: 0.4rem;
                "
                v-model="i.value2"
              />
            </vs-col>
          </vs-row>
          <template #modal-footer="{}">
            <vs-button
              color="primary"
              @click="saveColorMap(optionsColor, optionsColorC)"
              class="mr-1 btnBorderpop"
              type="filled"
              >Save</vs-button
            >
            <vs-button
              @click="closeModal2"
              class="btnBorderpop"
              color="dark"
              type="flat"
              >Cancel</vs-button
            >
          </template>
        </b-modal>
      </vs-row>
      <!-- old version -->
      <!-- <vs-row>
        <vs-col vs-w="3" vs-lg="3" vs-sm="12" vs-xs="12">
          <vs-card class="mr-3" style="border-radius: 15px">
            <vs-row id="center">
              <vs-list-header
                :title="nameTemp1"
                style="font-size: 15px"
                color="dark"
              ></vs-list-header>
              <vs-spacer />
              <toggle-button
                :value="tempStatus1"
                :sync="true"
                color="#13ECE0"
              />
            </vs-row>
            <vs-row>
              <img src="../../../../assets/images/tempsensor.png" />
              <vs-col vs-w="5">
                <h6 class="mt-3">Temperature</h6>
                <h5 class="mt-3" align="center">{{ temp1 }} ํC</h5>
                <h6 class="mt-3">Humidity</h6>
                <h5 class="mt-3" align="center">{{ humid1 }}%</h5>
              </vs-col>
            </vs-row>
            <vs-progress
              class="mt-3"
              :height="8"
              :percent="((temp1 + 40) / (70 + 40)) * 100"
              :color="color1"
              style="background: #ececec"
            ></vs-progress>
          </vs-card>
        </vs-col>
        <vs-col vs-w="3" vs-lg="3" vs-sm="12" vs-xs="12">
          <vs-card class="mr-3" style="border-radius: 15px">
            <vs-row id="center">
              <vs-list-header
                :title="nameTemp2"
                style="font-size: 15px"
                color="dark"
              ></vs-list-header>
              <vs-spacer />
              <toggle-button
                :value="tempStatus2"
                :sync="true"
                color="#13ECE0"
              />
            </vs-row>
            <vs-row>
              <img src="../../../../assets/images/tempsensor.png" />
              <vs-col vs-w="5">
                <h6 class="mt-3">Temperature</h6>
                <h5 class="mt-3" align="center">{{ temp2 }} ํC</h5>
                <h6 class="mt-3">Humidity</h6>
                <h5 class="mt-3" align="center">{{ humid2 }}%</h5>
              </vs-col>
            </vs-row>
            <vs-progress
              class="mt-3"
              :height="8"
              :percent="((temp2 + 40) / (70 + 40)) * 100"
              :color="color2"
              style="background: #ececec"
            ></vs-progress>
          </vs-card>
        </vs-col>
        <vs-col vs-w="3" vs-lg="3" vs-sm="12" vs-xs="12">
          <vs-card class="mr-3" style="border-radius: 15px">
            <vs-row id="center">
              <vs-list-header
                :title="nameTemp3"
                style="font-size: 15px"
                color="dark"
              ></vs-list-header>
              <vs-spacer />
              <toggle-button
                :value="tempStatus3"
                :sync="true"
                color="#13ECE0"
              />
            </vs-row>
            <vs-row>
              <img src="../../../../assets/images/tempsensor.png" />
              <vs-col vs-w="5">
                <h6 class="mt-3">Temperature</h6>
                <h5 class="mt-3" align="center">{{ temp3 }} ํC</h5>
                <h6 class="mt-3">Humidity</h6>
                <h5 class="mt-3" align="center">{{ humid3 }}%</h5>
              </vs-col>
            </vs-row>
            <vs-progress
              class="mt-3"
              :height="8"
              :percent="((temp3 + 40) / (70 + 40)) * 100"
              :color="color3"
              style="background: #ececec"
            ></vs-progress>
          </vs-card>
        </vs-col>
        <vs-col vs-w="3" vs-lg="3" vs-sm="12" vs-xs="12">
          <vs-card class="mr-3" style="border-radius: 15px">
            <vs-row id="center">
              <vs-list-header
                :title="nameTemp4"
                style="font-size: 15px"
                color="dark"
              ></vs-list-header>
              <vs-spacer />
              <toggle-button
                :value="tempStatus4"
                :sync="true"
                color="#13ECE0"
              />
            </vs-row>
            <vs-row>
              <img src="../../../../assets/images/tempsensor.png" />
              <vs-col vs-w="5">
                <h6 class="mt-3">Temperature</h6>
                <h5 class="mt-3" align="center">{{ temp4 }} ํC</h5>
                <h6 class="mt-3">Humidity</h6>
                <h5 class="mt-3" align="center">{{ humid4 }}%</h5>
              </vs-col>
            </vs-row>
            <vs-progress
              class="mt-3"
              :height="8"
              :percent="((temp4 + 40) / (70 + 40)) * 100"
              :color="color4"
              style="background: #ececec"
            ></vs-progress>
          </vs-card>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col>
          <vs-card style="border-radius: 15px; padding-left: 5">
            <vs-select autocomplete @change="generateData()" v-model="select1">
              <vs-select-item
                :key="index"
                :value="item.mac"
                :text="item.name"
                v-for="(item, index) in select"
              />
            </vs-select>
            <div id="app">
              <SensorChart
                v-if="chart"
                :chartData="this.chartData"
                :options="this.options"
                style="height: 300px"
              />
              <div align="center">
                <vs-row>
                  <vs-col vs-w="4"
                    ><vs-card
                      ><h5>Min Temp: {{ minValTemp }} ํC</h5></vs-card
                    ></vs-col
                  >
                  <vs-col vs-w="4"
                    ><vs-card
                      ><h5>Max Temp: {{ maxValTemp }} ํC</h5></vs-card
                    ></vs-col
                  >
                  <vs-col vs-w="4"
                    ><vs-card
                      ><h5>
                        Avg Temp: {{ avgValTemp.toFixed(2) }} ํC
                      </h5></vs-card
                    ></vs-col
                  >
                </vs-row>
                <vs-row>
                  <vs-col vs-w="4"
                    ><vs-card
                      ><h5>Min Humid: {{ minValHumid }} %</h5></vs-card
                    ></vs-col
                  >
                  <vs-col vs-w="4"
                    ><vs-card
                      ><h5>Max Humid: {{ maxValHumid }} %</h5></vs-card
                    ></vs-col
                  >
                  <vs-col vs-w="4">
                    <vs-card
                      ><h5>
                        Avg Humid: {{ avgValHumid.toFixed(2) }} %
                      </h5></vs-card
                    ></vs-col
                  >
                </vs-row>
              </div>
            </div>
          </vs-card>
          <vs-card style="border-radius: 15px; padding-left: 5">
            <vs-table
              :data="tableTemp"
              max-items="4"
              pagination
              style="width: 50"
            >
              <template slot="header">
                <vs-list-header
                  title="Sensors List"
                  style="font-size: 18px"
                  color="dark"
                ></vs-list-header>
              </template>
              <template slot="thead">
                <vs-th align="center"> Timestamp </vs-th>
                <vs-th> Sensor Name </vs-th>
                <vs-th> Mac Address </vs-th>
                <vs-th> Temperature </vs-th>
                <vs-th> Humidity </vs-th>
                <vs-th> Battery </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].date">
                    {{ data[indextr].date }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>
                  <vs-td :data="data[indextr].mac">
                    {{ data[indextr].mac }}
                  </vs-td>
                  <vs-td :data="data[indextr].temp">
                    {{ data[indextr].temp }}
                  </vs-td>
                  <vs-td :data="data[indextr].humid">
                    {{ data[indextr].humid }}
                  </vs-td>
                  <vs-td :data="data[indextr].batt">
                    {{ data[indextr].batt }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-card>
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col vs-w="3">
          <vs-card class="mr-3" style="border-radius: 15px">
            <vs-row id="center">
              <vs-list-header
                :title="nameDoor1"
                style="font-size: 15px"
                color="dark"
              ></vs-list-header>
              <vs-spacer />
              <toggle-button
                :value="doorStatus1"
                :sync="true"
                color="#13ECE0"
              />
            </vs-row>
            <vs-row>
              <img
                src="../../../../assets/images/doorsensor.png"
                width="100"
                height="150"
              />
              <vs-col vs-w="6">
                <h6 class="mt-3">Install Status</h6>
                <toggle-button
                  class="mt-3"
                  :value="install1"
                  color="#32c040"
                  align="center"
                  :sync="true"
                />
                <h6 class="mt-3">Door Status</h6>
                <toggle-button
                  class="mt-3"
                  :value="door1"
                  :sync="true"
                  color="#32c040"
                  align="center"
                />
              </vs-col>
            </vs-row>
          </vs-card>
        </vs-col>
        <vs-col vs-w="3">
          <vs-card class="mr-3" style="border-radius: 15px">
            <vs-row id="center">
              <vs-list-header
                :title="nameDoor2"
                style="font-size: 15px"
                color="dark"
              ></vs-list-header>
              <vs-spacer />
              <toggle-button
                :value="doorStatus2"
                :sync="true"
                color="#13ECE0"
              />
            </vs-row>
            <vs-row>
              <img
                src="../../../../assets/images/doorsensor.png"
                width="100"
                height="150"
              />
              <vs-col vs-w="6">
                <h6 class="mt-3">Install Status</h6>
                <toggle-button
                  class="mt-3"
                  :value="install2"
                  :sync="true"
                  color="#32c040"
                  align="center"
                />
                <h6 class="mt-3">Door Status</h6>
                <toggle-button
                  class="mt-3"
                  :value="door2"
                  :sync="true"
                  color="#32c040"
                  align="center"
                />
              </vs-col>
            </vs-row>
          </vs-card>
        </vs-col>
        <vs-col vs-w="3">
          <vs-card class="mr-3" style="border-radius: 15px">
            <vs-row id="center">
              <vs-list-header
                :title="nameDoor3"
                style="font-size: 15px"
                color="dark"
              ></vs-list-header>
              <vs-spacer />
              <toggle-button
                :value="doorStatus3"
                :sync="true"
                color="#13ECE0"
              />
            </vs-row>
            <vs-row>
              <img
                src="../../../../assets/images/doorsensor.png"
                width="100"
                height="150"
              />
              <vs-col vs-w="6">
                <h6 class="mt-3">Install Status</h6>
                <toggle-button
                  class="mt-3"
                  :value="install3"
                  :sync="true"
                  color="#32c040"
                  align="center"
                />
                <h6 class="mt-3">Door Status</h6>
                <toggle-button
                  class="mt-3"
                  :value="door3"
                  :sync="true"
                  color="#32c040"
                  align="center"
                />
              </vs-col>
            </vs-row>
          </vs-card>
        </vs-col>
        <vs-col vs-w="3">
          <vs-card class="mr-3" style="border-radius: 15px">
            <vs-row id="center">
              <vs-list-header
                :title="nameDoor4"
                style="font-size: 15px"
                color="dark"
              ></vs-list-header>
              <vs-spacer />
              <toggle-button
                :value="doorStatus4"
                :sync="true"
                color="#13ECE0"
              />
            </vs-row>
            <vs-row>
              <img
                src="../../../../assets/images/doorsensor.png"
                width="100"
                height="150"
              />
              <vs-col vs-w="6">
                <h6 class="mt-3">Install Status</h6>
                <toggle-button
                  class="mt-3"
                  :value="install4"
                  :sync="true"
                  color="#32c040"
                  align="center"
                />
                <h6 class="mt-3">Door Status</h6>
                <toggle-button
                  class="mt-3"
                  :value="door4"
                  :sync="true"
                  color="#32c040"
                  align="center"
                />
              </vs-col>
            </vs-row>
          </vs-card>
        </vs-col>
      </vs-row>
    </div>

 <//////////////////////////////////////////////////////////////////// Camillian //////////////////////////////////////////////////////////////// -->
    </div>
    <div v-else-if="user === 'pttdemo'">
      <vs-row
        vs-align="flex-end"
        vs-type="flex"
        vs-justify="space-between"
        vs-w="12"
      >
        <LastEssetStatep />
      </vs-row>
    </div>

    <!-- /////////////////////////////////////////////////////////////////////// -->

    <div v-else-if="user === 'syntecdemo' || user === 'swiftdemo' ">
      <vs-row
        vs-type="flex"
        vs-align="flex-end"
        vs-justify="space-between"
        vs-w="12"
      >
        <LastEssetStateps />
      </vs-row>
    </div>
    <div v-else-if="user === 'SCGdemo'||user === 'TAdemo' ">
      <vs-row
        vs-type="flex"
        vs-align="flex-end"
        vs-justify="space-between"
        vs-w="12"
      >
        <LastEssetStatepSCG />
      </vs-row>
    </div>
    <div v-else-if="user === 'Ramademo'">
      <vs-row
        vs-type="flex"
        vs-align="flex-end"
        vs-justify="space-between"
        vs-w="12"
      >
        <LastEssetStatepRama />
      </vs-row>
    </div>
    <!-- <div v-else-if="user === 'camilliandemo'">
      <vs-row vs-justify="center">
        <vs-col
          style="padding: 0; padding-right: 15px"
          type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
        >
          <vs-card class="cardx" style="display: inline">
            <div slot="header">
              <h3 align="center">Medicine Storage Room 1</h3>
            </div>
            <vs-row>
              <vs-col vs-w="6" style="padding: 0">
                <vs-card
                  style="border-radius: 15px; margin-bottom: 0; height: 215px"
                >
                  <vs-row id="center">
                    <vs-list-header
                      :title="gw1n"
                      style="font-size: 15px"
                      color="dark"
                    ></vs-list-header>
                  </vs-row>
                  <vs-row>
                    <img
                      src="../../../../assets/images/gateway.png"
                      width="100"
                      height="100"
                    />
                    <vs-col vs-w="6" style="padding: 0; padding-left: 15px">
                      <h6 class="font-weight-bold">MAC Address</h6>
                      <h6 class="mt-1">AC233FC064DB</h6>
                      <h6 class="mt-2 font-weight-bold">
                        Status
                        <vs-icon
                          v-if="st1 === 'Active'"
                          align="center"
                          icon="fiber_manual_record"
                          color="primary"
                        >
                        </vs-icon>
                        <vs-icon
                          v-if="st1 === 'Inactive'"
                          align="center"
                          icon="fiber_manual_record"
                          color="red"
                        >
                        </vs-icon>
                      </h6>
                      <h6 class="mt-2 font-weight-bold">Last Seen</h6>
                      <p class="mt-1">{{ lt1 }}</p>
                    </vs-col>
                  </vs-row>
                </vs-card>
              </vs-col>
              <vs-col vs-w="6" style="padding: 0; padding-left: 15px">
                <vs-card style="border-radius: 15px; height: 215px">
                  <vs-row id="center">
                    <vs-list-header
                      title="Asset"
                      style="font-size: 15px"
                      color="dark"
                    ></vs-list-header>
                  </vs-row>
                  <vs-row>
                    <img
                      src="../../../../assets/images/asset.png"
                      width="80"
                      height="100"
                    />
                    <vs-col vs-w="6" style="padding: 0">
                      <h6 class="font-weight-bold">Actual Found: 5</h6>
                      <h6 class="mt-2 font-weight-bold">Today Found: {{staf1}}</h6>
                    </vs-col>
                  </vs-row>
                </vs-card>
              </vs-col>
            </vs-row>
            <vs-row
              vs-align="flex-end"
              vs-type="flex"
              vs-justify="space-between"
              vs-w="12"
            >
              <vs-col
                style="padding: 0"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="12"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-card style="border-radius: 15px; padding-left: 5">
                  <vs-table :data="tableTempDB" max-items="5" pagination>
                    <template slot="header">
                      <vs-list-header
                        title="Asset Tags"
                        style="font-size: 18px"
                        color="dark"
                      ></vs-list-header>
                    </template>
                    <template slot="thead">
                      <vs-th sortKey="name">
                        Name <vs-icon icon="swap_vert" size="small"></vs-icon>
                      </vs-th>
                      <vs-th> Mac Address </vs-th>
                      <vs-th> Distance </vs-th>
                      <vs-th> rssi </vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].name">
                          <vs-button
                            id="noWrap"
                            @click="viewSensor(tr)"
                            icon="signal_cellular_alt"
                            type="flat"
                            >{{ data[indextr].name }}</vs-button
                          >
                        </vs-td>

                        <vs-td :data="data[indextr].mac">
                          {{ data[indextr].mac }}
                        </vs-td>
                        <vs-td :data="data[indextr].dis">
                          {{ data[indextr].dis }}
                        </vs-td>

                        <vs-td :data="data[indextr].rssi">
                          {{ data[indextr].rssi }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </vs-card>
              </vs-col>
            </vs-row>
          </vs-card>
        </vs-col>
        <vs-col
          style="padding: 0; padding-right: 15px"
          type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
        >
          <vs-card class="cardx" style="display: inline">
            <div slot="header">
              <h3 align="center">Medicine Storage Room 2</h3>
            </div>
            <vs-row>
              <vs-col vs-w="6" style="padding: 0">
                <vs-card
                  style="border-radius: 15px; margin-bottom: 0; height: 215px"
                >
                  <vs-row id="center">
                    <vs-list-header
                      :title="gw2n"
                      style="font-size: 15px"
                      color="dark"
                    ></vs-list-header>
                  </vs-row>
                  <vs-row>
                    <img
                      src="../../../../assets/images/gateway.png"
                      width="100"
                      height="100"
                    />
                    <vs-col vs-w="6" style="padding: 0; padding-left: 15px">
                      <h6 class="font-weight-bold">MAC Address</h6>
                      <h6 class="mt-1">AC233FC064BF</h6>
                      <h6 class="mt-2 font-weight-bold">
                        Status
                        <vs-icon
                          v-if="st1 === 'Active'"
                          align="center"
                          icon="fiber_manual_record"
                          color="primary"
                        >
                        </vs-icon>
                        <vs-icon
                          v-if="st1 === 'Inactive'"
                          align="center"
                          icon="fiber_manual_record"
                          color="red"
                        >
                        </vs-icon>
                      </h6>
                      <h6 class="mt-2 font-weight-bold">Last Seen</h6>
                      <p class="mt-1">{{ lt1 }}</p>
                    </vs-col>
                  </vs-row>
                </vs-card>
              </vs-col>
              <vs-col vs-w="6" style="padding: 0; padding-left: 15px">
                <vs-card style="border-radius: 15px; height: 215px">
                  <vs-row id="center">
                    <vs-list-header
                      title="Asset"
                      style="font-size: 15px"
                      color="dark"
                    ></vs-list-header>
                  </vs-row>
                  <vs-row>
                    <img
                      src="../../../../assets/images/asset.png"
                      width="80"
                      height="100"
                    />
                    <vs-col vs-w="6" style="padding: 0">
                      <h6 class="font-weight-bold">Actual Found: 5</h6>
                      <h6 class="mt-2 font-weight-bold">Today Found: {{staf2}}</h6>
                    </vs-col>
                  </vs-row>
                </vs-card>
              </vs-col>
            </vs-row>
            <vs-row
              vs-align="flex-end"
              vs-type="flex"
              vs-justify="space-between"
              vs-w="12"
            >
              <vs-col
                style="padding: 0"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="12"
                vs-sm="12"
                vs-xs="12"
              >
                <vs-card style="border-radius: 15px; padding-left: 5">
                  <vs-table :data="tableTempBF" max-items="5" pagination>
                    <template slot="header">
                      <vs-list-header
                        title="Asset Tags"
                        style="font-size: 18px"
                        color="dark"
                      ></vs-list-header>
                    </template>
                    <template slot="thead">
                      <vs-th sortKey="name">
                        Name <vs-icon icon="swap_vert" size="small"></vs-icon>
                      </vs-th>
                      <vs-th> Mac Address </vs-th>
                      <vs-th> Distance </vs-th>
                      <vs-th> rssi </vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].name">
                          <vs-button
                            id="noWrap"
                            @click="viewSensor(tr)"
                            icon="signal_cellular_alt"
                            type="flat"
                            >{{ data[indextr].name }}</vs-button
                          >
                        </vs-td>

                        <vs-td :data="data[indextr].mac">
                          {{ data[indextr].mac }}
                        </vs-td>
                        <vs-td :data="data[indextr].dis">
                          {{ data[indextr].dis }}
                        </vs-td>

                        <vs-td :data="data[indextr].rssi">
                          {{ data[indextr].rssi }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </vs-card>
              </vs-col>
            </vs-row>
          </vs-card>
        </vs-col>
      </vs-row>
    </div> -->
    <div v-else-if="user === 'camilliandemo'">
      <vs-row
        vs-align="flex-end"
        vs-type="flex"
        vs-justify="space-between"
        vs-w="12"
      >
        <LastEssetStateC />
      </vs-row>
    </div>
    <!-- /////////////////////////////////////////////////////////////////////// -->
    <div v-else-if="user === 'spartan'">
      <vs-row
        vs-align="flex-end"
        vs-type="flex"
        vs-justify="space-between"
        vs-w="12"
      >
        <LastEssetStateS />
      </vs-row>
    </div>
  </div>
</template>
<script>
import SensorChart from "./components/SensorChart";
import SensorChart2 from "./components/SensorChart";
import LastEssetStatep from "../../dashboard/Overview/PTTCom/IndoorDashboard.vue";
import LastEssetStateps from "../../dashboard/syntec/dashboard.vue";
import LastEssetStatepSCG from "../../dashboard/SCG/dashboard.vue";
import LastEssetStatepRama from "../../dashboard/Rama/dashboard.vue";


// import LastEssetStateps from "../../dashboard/Overview/Syntec/IndoorDashboard.vue";
import LastEssetStateC from "../../dashboard/Overview/CamillianCom/IndoorDashboard.vue";
import LastEssetStateS from "../../dashboard/Overview/SpartanCom/IndoorDashboard.vue";
import { ToggleButton } from "vue-js-toggle-button";
import moment from "moment";

export default {
  components: {
    SensorChart,
    SensorChart2,
    ToggleButton,
    LastEssetStatep,
    LastEssetStateps,
    LastEssetStateC,
    LastEssetStateS,
    LastEssetStatepSCG,
    LastEssetStatepRama,
  },
  data: () => ({
    valueName: "",
    valueOldName: "",
    arrSensorName: "",
    optionsColor: [
      { text: "Red", icon: ">", color: "textDanger", value2: "" },
      {
        text: "Yellow",
        icon: "-",
        color: "textYellow",
        value1: "1",
        value2: "1",
      },
      {
        text: "Green",
        icon: "<",
        color: "colorSuccess",
        value2: "",
      },
    ],
    optionsColorC: [
      { text: "Red", icon: ">", color: "textDanger", value2: "" },
      {
        text: "Yellow",
        icon: "-",
        color: "textYellow",
        value1: "",
        value2: "",
      },
      {
        text: "Green",
        icon: "<",
        color: "colorSuccess",
        value2: "",
      },
    ],
    arrSensor: [],
    itemDoor2: [
      "F1",
      "F2",
      "F3",
      "F4",
      "F5",
      "F6",
      "F7",
      "F8",
      "F9",
      "F10",
      "F11",
      "F12",
      "F13",
      "F14",
    ],
    itemZoneC: ["C1", "C2", "C3", "C4", "C5", "C6", "C7", "C8"],
    itemZoneC1: ["C1", "C2", "C3"],
    itemZoneC2: ["C4", "C5", "C6", "C7", "C8"],
    itemZoneF: [
      "F1",
      "F2",
      "F3",
      "F4",
      "F5",
      "F6",
      "F7",
      "F8",
      "F9",
      "F10",
      "F11",
      "F12",
      "F13",
      "F14",
    ],
    data: [
      {
        date: "20/08/2021",
        name: "fridge01",
        mac: "123456789",
        temp: "21",
        humid: "40",
        batt: "100%",
      },
      {
        date: "20/08/2021",
        name: "fridge01",
        mac: "123456789",
        temp: "21",
        humid: "40",
        batt: "100%",
      },
      {
        date: "20/08/2021",
        name: "fridge01",
        mac: "123456789",
        temp: "21",
        humid: "40",
        batt: "100%",
      },
      {
        date: "20/08/2021",
        name: "fridge01",
        mac: "123456789",
        temp: "21",
        humid: "40",
        batt: "100%",
      },
    ],
    itemTemp: [],
    // timeDiff: moment(Date.now()),
    itemDoor: [],
    options1: [
      { text: "C1" },
      { text: "C2" },
      { text: "C3" },
      { text: "C4" },
      { text: "C5" },
      { text: "C6" },
      { text: "C7" },
      { text: "C8" },
      { text: "F1" },
      { text: "F2" },
      { text: "F3" },
      { text: "F4" },
      { text: "F5" },
      { text: "F6" },
      { text: "F7" },
      { text: "F8" },
      { text: "F9" },
      { text: "F10" },
      { text: "F11" },
      { text: "F12" },
      { text: "F13" },
      { text: "F14" },
    ],
    headerTable: [
      "Timestamp",
      "Sensor Name",
      "Mac Address",
      "Temperature",
      "Humidity",
      "Battery",
    ],
    headerTableMap2: [
      "Sensor Name",
      "Install Status",
      "Door Status",
      "Battery",
      "Last Update",
      "Location",
    ],
    headerTableMap: [
      "Sensor Name",
      "Temperature",
      "Humidity",
      "Battery",
      "Last Update",
      "Location",
    ],
    users: [
      {
        id: 1,
        name: "Temp04",
        temp: "25.7",
        humid: "61.57",
        location: "B1",
      },
      {
        id: 2,
        name: "Temp03",
        temp: "26.9",
        humid: "60.34",
        location: "B3",
      },
      {
        id: 3,
        name: "Temp02",
        temp: "25.7",
        humid: "57.9",
        location: "B2",
      },
      {
        id: 4,
        name: "Temp01",
        temp: "25.7",
        humid: "60.57",
        location: "B4",
      },
    ],
    users2: [
      {
        id: 5,
        name: "Temp05",
        temp: "25.7",
        humid: "60.67",
        location: "B5",
      },
      {
        id: 6,
        name: "Temp02",
        temp: "25.7",
        humid: "57.9",
        location: "B6",
      },
      {
        id: 7,
        name: "Temp01",
        temp: "25.7",
        humid: "60.57",
        location: "B7",
      },
      {
        id: 8,
        name: "Temp05",
        temp: "25.7",
        humid: "60.67",
        location: "B8",
      },
    ],
    newArray1: [],
    newArray2: [],
    chartData2: null,
    chartData: null,
    options: null,
    dateTime: [],
    door1: null,
    door2: null,
    door3: null,
    door4: null,
    install1: null,
    install2: null,
    install3: null,
    install4: null,
    temp1: 0,
    temp2: 0,
    temp3: 0,
    temp4: 0,
    humid1: 0,
    humid2: 0,
    humid3: 0,
    humid4: 0,
    color1: null,
    color2: null,
    color3: null,
    color4: null,
    tempStatus1: false,
    tempStatus2: false,
    tempStatus3: false,
    tempStatus4: false,
    doorStatus1: false,
    doorStatus2: false,
    doorStatus3: false,
    doorStatus4: false,
    nameTemp1: null,
    nameTemp2: null,
    nameTemp3: null,
    nameTemp4: null,
    nameDoor1: null,
    nameDoor2: null,
    nameDoor3: null,
    nameDoor4: null,
    tableTemp: [],
    tableTempDB: [],
    tableTempBF: [],
    dataTpr: [],
    selectTpr: [],
    select: [],
    select1: null,
    chart: false,
    maxValTemp: 0,
    minValTemp: 0,
    sumValTemp: 0,
    avgValTemp: 0,
    maxValHumid: 0,
    minValHumid: 0,
    sumValHumid: 0,
    avgValHumid: 0,
    user: "",
    dataRoom: [],
    dataRoom2: [],
    st1: "",
    lt1: "",
    gw1n: "",
    gw2n: "",
    totalAsset1: 0,
    totalAsset2: 0,
    sta1: "",
    sta2: "",
    staf1: 0,
    staf2: 0,
    getAssetIndoor: [],
    admin: "",
    gateway: [],
    tagfound: [],
    dataTpr: [],
    realData: [],
    actual: 0,
    today: 0,
    total: 0,
    asset: 0,
    totalAsset: 0,
    tpr: 0,
    totalManhour: [],
    dateManhour: [],
    totalManhorExport: [],
    assetfound: [],
    tprAsset: [],
    resultIndoorManHour: [],
    resultIndoorTagManHour: [],
    dataMergeManHour: [],
    show: true,
    alertDate: false,
    targetDatevalue: "",
    targetValue: 0,
    activeLoading: false,
    resultLogSensor: [],
    macname: "",
    mintime: "",
    maxtime: "",
    curt: "",
    interval: "",
  }),
  methods: {
    saveColorMap(item1, item2) {
      const body1 = {
        red: [parseFloat(item1[0].value2)],
        yellow: [parseFloat(item1[1].value1), parseFloat(item1[1].value2)],
        green: [parseFloat(item1[2].value2)],
      };
      this.$API.post("btg/config/map/1", body1).then((result) => {
        this.$refs["modal-2"].hide();
        //console.log(result);
        this.$vs.notify({
          title: "Color Rule Setting",
          text: "Temperature Rule setting success",
          color: "success",
          position: "top-center",
        });
      });
      const body2 = {
        red: [parseFloat(item2[0].value2)],
        yellow: [parseFloat(item2[1].value1), parseFloat(item2[1].value2)],
        green: [parseFloat(item2[2].value2)],
      };
      this.$API.post("btg/config/map/2", body2).then((result) => {
        this.$refs["modal-2"].hide();
        //console.log(result);
        // this.$vs.notify({
        //   title: "Edit Branch Name",
        //   text: "Branch name edit success",
        //   color: "success",
        //   position: "top-center",
        // });
      });
    },
    changeLocation(item) {
      //console.log("ccccccccccccccccccccccccccccccccccccccccccccccc");
      //console.log(item.mac);
      const body = { mac: item.mac, location: item.location };
      this.$API.post("indoorsensor/update/location", body).then((result) => {
        //console.log("ssssssssssssssssssssss");
        //console.log(result);
      });
    },
    getSelect() {
      //  this.$API.get("indoorgateway/AC233FC0BA7A").then((result1) => {
      //       //console.log(result1.data[0].sensorfound);
      //        for(var i=0;i<=result1.data[0].sensorfound.length;i++){
      //            let obj = result1.data[0].sensorfound[i];
      this.$API.get("indoorsensor/").then((result) => {
        //console.log(result.data);
        // this.select.push({ mac: "Custom", name: "Custom" });
        for (var i = 0; i <= result.data.length; i++) {
          let obj = result.data[i];
          // console.log(obj);
          if (obj != undefined) {
            
          
          if (obj.subtype == "S1") {
            let payload = { mac: obj.mac, name: obj.name };
            this.select.push(payload);

            //console.log(this.select);
            this.select1 = this.select[0].mac;
            payload = {};
          }
          if (obj.mac == "AC233FAA24B8") {
            this.nameTemp1 = obj.name;
            this.arrSensorName = obj.name;
          } else if (obj.mac == "AC233FAA24B5") {
            this.nameTemp2 = obj.name;
          } else if (obj.mac == "AC233FAA24B6") {
            this.nameTemp3 = obj.name;
          } else if (obj.mac == "AC233FAA24B9") {
            this.nameTemp4 = obj.name;
          } else if (obj.mac == "AC233FA9DA04") {
            this.nameDoor1 = obj.name;
          } else if (obj.mac == "AC233FA9DA05") {
            this.nameDoor2 = obj.name;
          } else if (obj.mac == "AC233FA9DA03") {
            this.nameDoor3 = obj.name;
          } else if (obj.mac == "AC233FA9DA06") {
            this.nameDoor4 = obj.name;
          }
          }
        }

        //  if(obj.type=="S1"){
        //     let payload = {mac:obj.mac,name:result2.data[0].name};
        //      this.select1 = result1.data[0].sensorfound[0].mac;
        //     this.selectTpr.push(payload);
        //     payload = {};
        //     //console.log(this.select);
        //  }
      });
      //  this.select.push({ mac: "Custom", name: "Custom" });
      //        }
      //     })
    },

    viewSensor(item) {
      //console.log(item.mac);
      this.$session.set("sensorname", item.name);
      this.$session.set("macname", item.mac);
      this.$session.set("type", item.type);

      // //console.log(this.network,item)
      this.$router.push({
        name: "AssetDashboardIndoor",
        params: {
          sensorname: this.name,
          macname: this.mac,
        },
      });
    },
    generateData() {
      this.chart = false;
      this.sumValHumid = 0;
      this.sumValTemp = 0;
      this.avgValTemp = 0;
      this.avgValHumid = 0;
      this.newArray1 = [];
      this.newArray2 = [];
      this.dateTime = [];
      //console.log(this.select1);
      this.$API.get("indoorsensorlog/AC233FAA24B8").then((result) => {
        console.log(result.data);
        for (var i = 0; i < result.data.length; i++) {
          let obj = result.data[i];
          this.newArray1.push(obj.sensordata.temperature);
          this.newArray2.push(obj.sensordata.humidity);
          this.dateTime.push(
            this.$moment(obj.timestamp).format("DD/MM/YYYY hh:mm a")
          );
        }
        this.maxValTemp = Math.max.apply(Math, this.newArray1);
        this.minValTemp = Math.min.apply(Math, this.newArray1);
        this.maxValHumid = Math.max.apply(Math, this.newArray2);
        this.minValHumid = Math.min.apply(Math, this.newArray2);
        for (var i = 0; i < this.newArray1.length; i++) {
          this.sumValTemp += this.newArray1[i];
        }
        this.avgValTemp = this.sumValTemp / this.newArray1.length;
        for (var i = 0; i < this.newArray2.length; i++) {
          this.sumValHumid += this.newArray2[i];
        }
        this.avgValHumid = this.sumValHumid / this.newArray2.length;
        //console.log(this.avgValTemp.toFixed(2));
        //console.log(this.avgValHumid.toFixed(2));
      });

      this.chartData = {
        labels: this.dateTime,
        datasets: [
          {
            label: "Temperature",
            type: "line",
            data: this.newArray1,
            fontColor: "rgb(212, 0, 255)",
            borderColor: "rgb(212, 0, 255)",
            borderWidth: 3,
          },
          {
            label: "Humidity",
            type: "line",
            data: this.newArray2,
            borderColor: "rgb(43, 160, 255)",
            borderWidth: 3,
          },
        ],
      };
      this.options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              id: "A",
              ticks: {
                beginAtZero: true,
                fontColor: "#ffffff",
              },
              position: "left",
              scaleLabel: {
                display: true,
                labelString: "Temp (C) / Humid ()",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "#ffffff",
              },
              scaleLabel: {
                display: true,
                labelString: "Timestamp",
              },
            },
          ],
        },
      };
      setTimeout(() => {
        this.chart = true;
      }, 1000);
    },
    getRandomColor() {
      var color = "hsl(" + Math.random() * 360 + ", 100%, 75%)";
      return color;
    },
    getChartData() {
      var array1 = [];
      var array2 = [];
      var dateTimelabel = [];
      var nameArrs = "";
      var dataset = [];
      var index = 0;
      var length1 = 0;
      var length2 = 0;
      this.sumValHumid = 0;
      this.sumValTemp = 0;
      this.avgValTemp = 0;
      this.avgValHumid = 0;
      var sumArray1 = 0;
      var sumArray2 = 0;
      this.newArray1 = [];
      var dataMac = [];
      var dataNameLabel = [];
      var randomColor = this.getRandomColor();
      this.newArray2 = [];
      this.dateTime = []; //console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
      console.log(this.arrSensor);
      this.arrSensorName = "";
      this.arrSensor.forEach((x) => {
        // console.log(x.mac);
        dataMac.push(x.mac);
        dataNameLabel.push(x.name);
        console.log(x.name);
        nameArrs += x.name + " ";
        // this.arrSensorName += (x.name + " ");
      });
      console.log(dataMac);
      this.$API
        .post("indoorsensorgraph/multiple", {
          sensorlist: dataMac,
          start: this.mintime,
          end: this.maxtime,
        })
        .then((result) => {
          // console.log(result.data);
          result.data.forEach((element) => {
            array1[index] = [];
            array2[index] = [];
            for (var i = 0; i < element.length; i++) {
              let obj = element[i];
              // console.log(obj);
              array1[index].push(obj.sensordata.temperature);
              array2[index].push(obj.sensordata.humidity);
              if (index == 0) {
                dateTimelabel.push(
                  this.$moment(obj.timestamp).format("DD/MM/YY hh:mmA")
                );
              }
            }
            index++;
            // this.maxValTemp = Math.max.apply(Math, array1);
            // this.minValTemp = Math.min.apply(Math, array1);
            // this.maxValHumid = Math.max.apply(Math, array2);
            // this.minValHumid = Math.min.apply(Math, array2);
            // console.log(array1);
            // for (var i = 0; i < array1.length; i++) {
            //   this.sumValTemp += array1[i];
            // }
            // this.avgValTemp = this.sumValTemp / array1.length;
            // for (var i = 0; i < array2.length; i++) {
            //   this.sumValHumid += array2[i];
            // }
            // this.avgValHumid = this.sumValHumid / array2.length;
            //console.log(this.avgValTemp.toFixed(2));
            //console.log(this.avgValHumid.toFixed(2));
            this.$refs["settingChart"].hide();
            this.arrSensorName = nameArrs;
          });
          // console.log(array1);
          array1.forEach((element, i) => {
            dataset.push(
              {
                label: "Temperature" + dataNameLabel[i],
                type: "line",
                data: array1[i],
                borderColor: this.getRandomColor(),
                borderWidth: 3,
              },
              {
                label: "Humidity" + dataNameLabel[i],
                type: "line",
                data: array2[i],
                borderColor: this.getRandomColor(),
                borderWidth: 3,
              }
            );

            sumArray1 += element.reduce((a, b) => a + b, 0);
            length1 += element.length;

            sumArray2 += array2[i].reduce((a, b) => a + b, 0);
            length2 += array2[i].length;

            this.maxValTemp = Math.max.apply(Math, array1[i]);
            this.minValTemp = Math.min.apply(Math, array1[i]);
            this.maxValHumid = Math.max.apply(Math, array2[i]);
            this.minValHumid = Math.min.apply(Math, array2[i]);
          });

          this.avgValTemp = sumArray1 / length1;
          this.avgValHumid = sumArray2 / length2;
          console.log(sumArray1, length1, sumArray1 / length1);
          console.log(sumArray2, length2, sumArray2 / length2);
          console.log(this.maxValTemp);
          console.log(this.minValTemp);
          console.log(this.maxValHumid);
          console.log(this.minValHumid);

          this.chartData = {
            labels: dateTimelabel,
            datasets: dataset,
          };
          this.options = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              position: "bottom",
            },
            scales: {
              yAxes: [
                {
                  id: "A",
                  ticks: {
                    beginAtZero: true,
                    fontColor: "#ffffff",
                  },
                  position: "left",
                  scaleLabel: {
                    display: true,
                    labelString: "Temp (C) / Humid (%)",
                  },
                },
              ],
              xAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    fontColor: "#ffffff",
                  },
                  scaleLabel: {
                    display: true,
                    labelString: "Timestamp",
                  },
                },
              ],
            },
          };
        });
    },

    // realtimeData() {
    //   this.sumValHumid = 0;
    //   this.sumValTemp = 0;
    //   this.avgValTemp = 0;
    //   this.avgValHumid = 0;
    //   // this.chart = false;
    //   this.$API.get("indoorsensorlog/" + this.select1).then((result) => {
    //     let obj = result.data[6];

    //     //console.log(result.data[6]);
    //     this.newArray1.push(obj.sensordata.temperature);
    //     this.newArray2.push(obj.sensordata.humidity);
    //     this.dateTime.push(moment(obj.timestamp).format("DD/MM/yyyy HH:mm a"));

    //     this.newArray1.splice(0, 1);
    //     this.newArray2.splice(0, 1);
    //     this.dateTime.splice(0, 1);
    //     //  this.newArray1.push(obj.sensordata.temperature);
    //     // this.newArray2.push(obj.sensordata.humidity);
    //     //  this.dateTime.push(moment(obj.timestamp).format('LTS'));

    //     // this.chart = true;
    //     this.maxValTemp = Math.max.apply(Math, this.newArray1);
    //     this.minValTemp = Math.min.apply(Math, this.newArray1);
    //     this.maxValHumid = Math.max.apply(Math, this.newArray2);
    //     this.minValHumid = Math.min.apply(Math, this.newArray2);
    //     //console.log(this.maxValTemp);
    //     //console.log(this.minValTemp);
    //     //console.log(this.maxValHumid);
    //     //console.log(this.minValHumid);
    //     for (var i = 0; i < this.newArray1.length; i++) {
    //       this.sumValTemp += this.newArray1[i];
    //     }
    //     this.avgValTemp = this.sumValTemp / this.newArray1.length;
    //     for (var i = 0; i < this.newArray2.length; i++) {
    //       this.sumValHumid += this.newArray2[i];
    //     }
    //     this.avgValHumid = this.sumValHumid / this.newArray2.length;
    //     //console.log(this.avgValTemp.toFixed(2));
    //     //console.log(this.avgValHumid.toFixed(2));
    //   });
    // },
    closeModal() {
      this.$refs["settingChart"].hide();
    },
    saveEditname(item) {
      //console.log(item);
      this.$API
        .post("btg/config/company/1", {
          company: item,
        })
        .then((result) => {
          this.$vs.notify({
            title: "Edit Branch Name",
            text: "Branch name edit success",
            color: "success",
            position: "top-center",
          });

          this.$refs["editname"].hide();
        });
    },
    closeEditname() {
      this.$refs["editname"].hide();
      this.$API.get("btg/config/company/1").then((result) => {
        this.valueName = result.data[0].company;
      });
    },
    closeModal2() {
      this.$refs["modal-2"].hide();
    },
    getSensorTableBG() {
      this.$API.get("indoorgateway/AC233FC064DB").then((result) => {
        //console.log(result);
        //console.log(result.statusText);
        if (result.statusText == "OK") {
          //console.log("OKKKKKKKKKKk");
          this.sta1 = "Active";
          this.staf1 = result.data[0].assetfound.length;
        }
        //console.log(result.data[0].assetfound.length);
      });

      this.$API.get("indoorgateway/AC233FC064BF").then((result) => {
        // //console.log(result);
        // //console.log(result.statusText);
        if (result.statusText == "OK") {
          //console.log("OKKKKKKKKKKk");
          this.sta2 = "Active";
          this.staf2 = result.data[0].assetfound.length;
        }
      });
    },

    getSensorTable() {
      this.dataTpr = [];
      this.tempStatus1 = false;
      this.tempStatus2 = false;
      this.tempStatus3 = false;
      this.tempStatus4 = false;
      this.doorStatus1 = false;
      this.doorStatus2 = false;
      this.doorStatus3 = false;
      this.doorStatus4 = false;
      this.$API.get("indoorgateway/AC233FC0BA7A").then((result1) => {
        // console.log(result1.data[0]);
        if (result1.data[0] != undefined) {
          
        
        for (var i = 0; i <= result1.data[0].sensorfound.length; i++) {
          if (result1.data[0].sensorfound[i])
            var obj = result1.data[0].sensorfound[i];
          this.$API.get("indoorsensor/" + obj.mac).then((result2) => {
            // console.log(result2.data);
            if (obj.mac == result2.data[0].mac) {
              if (obj.type == "S1") {
                let payload = {
                  date: moment(obj.timestamp).format("LLL"),
                  mac: obj.mac,
                  name: result2.data[0].name,
                  temp: obj.temperature,
                  humid: obj.humidity,
                  batt: obj.battery,
                  st: obj.lastdate,
                };
                this.dataTpr.push(payload);
                payload = {};
              }
              if (result2.data[0].mac == "AC233FAA24B8") {
                //console.log(obj.temperature);
                //console.log(obj.humidity);
                this.temp1 = obj.temperature;
                this.humid1 = obj.humidity;
                this.tempStatus1 = true;
                // this.nameTemp1 = result2.data[0].name;
              } else if (result2.data[0].mac == "AC233FAA24B5") {
                //console.log(obj.temperature);
                //console.log(obj.humidity);
                this.temp2 = obj.temperature;
                this.humid2 = obj.humidity;
                this.tempStatus2 = true;
                // this.nameTemp2 = result2.data[0].name;
              } else if (result2.data[0].mac == "AC233FAA24B6") {
                //console.log(obj.temperature);
                //console.log(obj.humidity);
                this.temp3 = obj.temperature;
                this.humid3 = obj.humidity;
                this.tempStatus3 = true;
                //  this.nameTemp3 = result2.data[0].name;
              } else if (result2.data[0].mac == "AC233FAA24B9") {
                //console.log(obj.temperature);
                //console.log(obj.humidity);
                this.temp4 = obj.temperature;
                this.humid4 = obj.humidity;
                this.tempStatus4 = true;
                //  this.nameTemp4 = result2.data[0].name;
              }

              //  else{
              //    this.tempStatus1 = false;
              //    this.tempStatus2 = false;
              //    this.tempStatus3 = false;
              //    this.tempStatus4 = false;
              //  }

              if (this.temp1 >= -40 && this.temp1 <= 4) {
                this.color1 = "#3EFF00";
              } else if (this.temp1 > 4 && this.temp1 <= 8) {
                this.color1 = "#FFF000";
              } else if (this.temp1 >= 8) {
                this.color1 = "#FF0000";
              }

              if (this.temp2 >= -40 && this.temp2 <= 4) {
                this.color2 = "#3EFF00";
              } else if (this.temp2 > 4 && this.temp2 <= 8) {
                this.color2 = "#FFF000";
              } else if (this.temp2 >= 8) {
                this.color2 = "#FF0000";
              }

              if (this.temp3 >= -40 && this.temp3 <= -15) {
                this.color3 = "#3EFF00";
              } else if (this.temp3 > -15 && this.temp3 <= -12) {
                this.color3 = "#FFF000";
              } else if (this.temp3 >= -12) {
                this.color3 = "#FF0000";
              }

              if (this.temp4 > -18 && this.temp4 <= -15) {
                this.color4 = "#3EFF00";
              } else if (this.temp4 > -15 && this.temp4 <= -12) {
                this.color4 = "#FFF000";
              } else if (this.temp4 >= -12) {
                this.color4 = "#FF0000";
              }

              if (result2.data[0].mac == "AC233FA9DA04") {
                //console.log(!obj.uninstalled);
                //console.log(!obj.unlocked);
                this.install1 = !obj.uninstalled;
                this.door1 = !obj.unlocked;
                this.doorStatus1 = true;
                // this.nameDoor1 = result2.data[0].name;
              } else if (result2.data[0].mac == "AC233FA9DA05") {
                //console.log(!obj.uninstalled);
                //console.log(!obj.unlocked);
                this.install1 = !obj.uninstalled;
                this.door1 = !obj.unlocked;
                this.doorStatus2 = true;
                // this.nameDoor2 = result2.data[0].name;
              } else if (result2.data[0].mac == "AC233FA9DA03") {
                //console.log(!obj.uninstalled);
                //console.log(!obj.unlocked);
                this.install1 = !obj.uninstalled;
                this.door1 = !obj.unlocked;
                this.doorStatus3 = true;
                // this.nameDoor3 = result2.data[0].name;
              } else if (result2.data[0].mac == "AC233FA9DA06") {
                //console.log(!obj.uninstalled);
                //console.log(!obj.unlocked);
                this.install1 = !obj.uninstalled;
                this.door1 = !obj.unlocked;
                this.doorStatus4 = true;
                // this.nameDoor4 = result2.data[0].name;
              }
            }
          });
        }
        }
      });
      setTimeout(() => {
        this.tableTemp = this.dataTpr;
        //console.log(this.tableTemp);
      }, 300);
    },

    getSensorTableDB() {
      this.dataRoom = [];

      this.$API.get("indoorgateway/AC233FC064DB").then((result) => {
        const data = result.data[0].assetfound;
        var currentTime = Date.now();
        currentTime = moment(currentTime);

        data.forEach((element) => {
          this.getAssetIndoor.forEach((element2) => {
            if (element.mac === element2.mac) {
              this.dataRoom.push({
                name: element2.name,
                mac: element2.mac,
                dis: Math.pow(10, (-52 - element.rssi) / (10 * 4)).toFixed(2),
                rssi: element.rssi,
              });
            }
          });
        });
        var timeDiff = currentTime.diff(moment(result.data[0].lastdate), "m");
        if (timeDiff <= 2) {
          this.st1 = "Active";
          // //console.log(this.today); h:mm:ss a
        } else {
          this.st1 = "Inactive";
        }
        this.gw1n = result.data[0].name;
        //console.log("gw1", result.data[0].assetfound);
        this.lt1 = moment(result.data[0].lastdate)
          .subtract(7, "hours")
          .format("l h:mm:ss a");
        this.totalAsset1 = result.data[0].assetfound.length;
      });

      setTimeout(() => {
        this.tableTempDB = this.dataRoom;
        //console.log(this.tableTemp);
      }, 300);
    },

    getSensorTableBF() {
      this.dataRoom2 = [];

      this.$API.get("indoorgateway/AC233FC064BF").then((result) => {
        const data = result.data[0].assetfound;
        //console.log("result", result);
        data.forEach((element) => {
          this.getAssetIndoor.forEach((element2) => {
            if (element.mac === element2.mac) {
              this.dataRoom2.push({
                name: element2.name,
                mac: element2.mac,
                dis: Math.pow(10, (-52 - element.rssi) / (10 * 4)).toFixed(2),
                rssi: element.rssi,
              });
            }
          });
        });
        this.totalAsset2 = result.data[0].assetfound.length;
        this.gw2n = result.data[0].name;
      });

      setTimeout(() => {
        this.tableTempBF = this.dataRoom;
        //console.log(this.tableTemp);
      }, 300);
    },
    callData(){
this.interval = setTimeout(async() => {
     await this.getSensorTable();

     await this.$API.get("indoorasset").then((result) => {
        this.getAssetIndoor = result.data;
      });

      (this.dataRoom = []), (this.dataRoom2 = []);
      this.callData()
    }, 1000);
    },
  },

  mounted() {
    this.admin = this.$session.get("admin")
    switch (this.user || this.admin) {
      case "betagrodemo":
        //console.log("betagrodemo");
        var elem = document.getElementsByClassName("con-vs-card");
        Array.prototype.filter.call(elem, function (testElement) {
          testElement.style.background = "#212121";
        });
        var elemselect = document.getElementsByClassName("vs-select--input");
        Array.prototype.filter.call(elemselect, function (testElementselect) {
          testElementselect.style.background = "#484848";
          testElementselect.style.color = "#ffffff";
        });
        var elemtable = document.getElementsByClassName("vs-con-table");
        Array.prototype.filter.call(elemtable, function (testElementtable) {
          testElementtable.style.background = "#212121";
          // testElementtable.style.color = "#484848";
        });
        var elemtableheader =
          document.getElementsByClassName("vs-table--header");
        Array.prototype.filter.call(
          elemtableheader,
          function (testElementtableheader) {
            testElementtableheader.style.background = "#212121";
          }
        );
        var elemtableul = document.getElementsByClassName("vs-pagination--ul");
        Array.prototype.filter.call(elemtableul, function (testElementtableul) {
          testElementtableul.style.background = "none";
        });
        if (window.innerWidth > 1536) {
          document.getElementById("pbGraph").style.paddingBottom = "1.7%";
        }
        console.log(window.innerWidth);
        // document.getElementById("backTable").style.backgroundColor = "lightblue";
        break;
      default:
      //console.log("Try looking up for a hint.");
    }
  },
  beforeDestroy() {
    clearTimeout(this.interval);
  },
  async created() {
    this.user = this.$session.get("username");
    // console.log("Timedeff",timeDiff);
    //console.log(this.user);
    // this.getSensor()
    this.getSensorTable();
    var currentTime = Date.now();
    currentTime = moment(currentTime);
    this.curt = currentTime;
    console.log("time", currentTime);
    console.log("curt", this.curt);
    this.$API.get("indoorsensor").then((result) => {
      console.log(result.data);
      result.data.forEach((element) => {
        if (element.name.match("Door")) {
          console.log("Door", element);
          this.itemDoor.push(element);
        }
        if (element.name.match("Temp")) {
          console.log("Temp", element);
          this.itemTemp.push(element);
        }
      });
      // this.getAssetIndoor = result.data;
    });

    await this.$API.get("btg/config/map/1").then((result) => {
      // console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaabbbbbbbbbbbbbbbbbb");
      console.log(result.data);

      this.optionsColor[0].value2 = result.data[0].red[0];
      this.optionsColor[1].value1 = result.data[0].yellow[0];
      this.optionsColor[1].value2 = result.data[0].yellow[1];
      this.optionsColor[2].value2 = result.data[0].green[0];
    });
    await this.$API.get("btg/config/map/2").then((result) => {
      // console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaabbbbbbbbbbbbbbbbbb");
      console.log(result.data);

      this.optionsColorC[0].value2 = result.data[0].red[0];
      this.optionsColorC[1].value1 = result.data[0].yellow[0];
      this.optionsColorC[1].value2 = result.data[0].yellow[1];
      this.optionsColorC[2].value2 = result.data[0].green[0];
      console.log(
        this.optionsColorC[1].value1,
        this.optionsColorC[1].value2,
        !!(
          this.optionsColorC[1].value1 <= -1 &&
          -1 <= this.optionsColorC[1].value2
        )
      );
    });
    await this.$API.get("btg/config/company/1").then((result) => {
      this.valueName = result.data[0].company;
      this.valueOldName = result.data[0].company;
    });
    // this.getTempParnel()
    // this.getDoorParnel()
    // this.tempSensor()
    // this. doorSensor()
    await this.getSelect();
    await this.generateData();
    //  this.realtimeData()
    // this.statusDevice()
    // this.statusDevice()
    this.callData()
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@300&display=swap");
.btnBorderpop {
  border-radius: 20px;
  width: 80px;
}
.fontBetagro {
  color: #32c040;
  font-size: 15px;
}
.fontSize2 {
  font-size: 1.5rem;
  padding-top: 10%;
}
.fontColorHeaderAVG {
  color: #ffffff;
  font-weight: 500;
  font-size: 0.9rem;
  /* white-space: nowrap; */
}
/* .fontBetagro {
  color: #32c040;
  font-size: 15px;
}
.fontSize2 {
  font-size: 2rem;
  white-space: nowrap;
  padding-top: 10%;
}
.fontColorHeaderAVG {
  color: #484848;
  font-weight: 700;
  font-size: 0.9rem;
} */
.textInfo {
  color: #00bbff;
}
#imageRight {
  margin-left: auto;
  margin-right: auto;
  width: 7.5rem;
  height: 11rem;
}
.imgMapFreacer {
  max-width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.img-wraps {
  position: relative;
  display: inline-block;
}
.img-wraps .F1 {
  position: absolute;
  top: 53%;
  right: 24.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F2 {
  position: absolute;
  top: 60%;
  right: 32.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F3 {
  position: absolute;
  top: 66%;
  right: 40.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F4 {
  position: absolute;
  top: 53%;
  right: 42.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F5 {
  position: absolute;
  top: 48%;
  right: 36.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F6 {
  position: absolute;
  top: 44.5%;
  right: 40.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F7 {
  position: absolute;
  top: 50%;
  right: 47%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F8 {
  position: absolute;
  top: 43.5%;
  right: 55%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F9 {
  position: absolute;
  top: 39%;
  right: 49%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F10 {
  position: absolute;
  top: 35.5%;
  right: 45%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F11 {
  position: absolute;
  top: 36.5%;
  right: 53%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F12 {
  position: absolute;
  top: 41%;
  right: 58%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F13 {
  position: absolute;
  top: 71.5%;
  right: 56.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F14 {
  position: absolute;
  top: 10%;
  right: 38%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}

.img-wraps .C1 {
  position: absolute;
  top: 14%;
  right: 20.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C2 {
  position: absolute;
  top: 10%;
  right: 25.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C3 {
  position: absolute;
  top: 5.5%;
  right: 31%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C4 {
  position: absolute;
  top: 11.5%;
  right: 50%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C5 {
  position: absolute;
  top: 15%;
  right: 54.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C6 {
  position: absolute;
  top: 18.5%;
  right: 59%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C7 {
  position: absolute;
  top: 22.5%;
  right: 63.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C8 {
  position: absolute;
  top: 26%;
  right: 68%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}

.img-wraps .F1D {
  position: absolute;
  top: 62%;
  right: 30.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F2D {
  position: absolute;
  top: 68.5%;
  right: 38%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F3D {
  position: absolute;
  top: 74.5%;
  right: 45.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F4D {
  position: absolute;
  top: 59%;
  right: 48%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F5D {
  position: absolute;
  top: 53.5%;
  right: 41%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F6D {
  position: absolute;
  top: 51%;
  right: 44%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F7D {
  position: absolute;
  top: 56.5%;
  right: 51%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F8D {
  position: absolute;
  top: 49.5%;
  right: 60.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F9D {
  position: absolute;
  top: 44%;
  right: 53.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F10D {
  position: absolute;
  top: 40.5%;
  right: 49.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F11D {
  position: absolute;
  top: 42%;
  right: 57.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F12D {
  position: absolute;
  top: 47.5%;
  right: 63.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F13D {
  position: absolute;
  top: 74%;
  right: 63%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .F14D {
  position: absolute;
  top: 15.5%;
  right: 38%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
/* 1-3 */
.img-wraps .C3D {
  position: absolute;
  top: 23.5%;
  right: 34.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C2D {
  position: absolute;
  top: 27.5%;
  right: 29.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C1D {
  position: absolute;
  top: 31%;
  right: 24.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C4D {
  position: absolute;
  top: 28.5%;
  right: 49.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C5D {
  position: absolute;
  top: 32.5%;
  right: 54.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C6D {
  position: absolute;
  top: 36.5%;
  right: 59.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C7D {
  position: absolute;
  top: 40.5%;
  right: 64.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
.img-wraps .C8D {
  position: absolute;
  top: 44.5%;
  right: 69.5%;
  z-index: 100;
  padding: 4px 3px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  line-height: 10px;
}
</style>
